export class ControleEstoqueDetalheReservasRequest {
  searchText?: string;
  idLocalizacaoEstoque?: number | null;
  dataInicial?: string | null;
  dataFinal?: string | null;
}
